/**
 * View component for /studies/:studyId
 *
 * Before Rome, this way the entire page for managing/editing a study. 
 * this page still exists as AdminSingleStudy but no longer has a route to it.
 * 
 * now, this page ONLY displayings the content management for that study, and 
 * the user management parts live in Rome.
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// import third-party libraries
import classNames from 'classnames';
import renderHTML from 'react-render-html';
import { DateTime } from 'luxon';

// import actions
import * as resourceLinkActions from '../../resourceLink/resourceLinkActions';
import * as studyActions from '../studyActions';
import * as sponsorActions from '../../sponsor/sponsorActions';
import * as studyUserActions from '../../studyUser/studyUserActions';
import * as courseActions from '../../course/courseActions';

// import global components
import AlertModal from '../../../global/components/modals/AlertModal.js.jsx';
import TrainingManagementLayout from '../../admin/components/TrainingManagementLayout.js.jsx';
import Base from "../../../global/components/BaseComponent.js.jsx";
import Breadcrumbs from '../../../global/components/routing/Breadcrumbs.js.jsx';
import { SelectFromArray, RadioInput } from '../../../global/components/forms';

// import utilities
import richContentUtils from '../../../global/utils/richContentUtils';

// import module components
import AdminCourseQuickListItem from '../../course/components/AdminCourseQuickListItem.js.jsx';
import AdminResourceLinkListItem from '../../resourceLink/components/AdminResourceLinkListItem.js.jsx';
import ResourceLinkModal from '../../resourceLink/components/ResourceLinkModal.js.jsx';
import StudyCustomEmailModal from '../components/StudyCustomEmailModal.js.jsx';

// import study css modules
import studyStyles from '../studyModuleStyles.css';

class AdminStudyTrainingManagement extends Base {
  constructor(props) {
    super(props);
    this.state = {
      createLinkModalOpen: false
      , createLinkModalOpen: false
      , confirmSendEmailsModalOpen: false
      , confirmCompletionReminder : false
      , confirmBulkResendModalOpen: false
      , emailStatusType: 'info'
      , emailStatusMessage: ''
      , createLinkModalOpen: false
      , customEmailModalOpen: false
      , customEmailBody: ''
      , customEmailSubject: ''
      , sendingEmails: false
      , status: ''
      , resultModalOpen: false
      , resultMessage: ""
      , resultType: "info"
    }
    this._bind(
      '_handleChange'
      , '_handleNewCustomStudyAlert'
      , '_handleNewMaterialAlert'
      , '_handleCompletionReminder'
      , '_handleBulkReminder'
    )
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch(studyActions.fetchSingleIfNeeded(match.params.studyId));
    dispatch(sponsorActions.fetchListIfNeeded());
    dispatch(resourceLinkActions.fetchListIfNeeded('_group', match.params.studyId));
    dispatch(courseActions.fetchListIfNeeded('_group', match.params.studyId));
  }

  componentWillReceiveProps(nextProps) {
    const { dispatch, match } = this.props;
    dispatch(resourceLinkActions.fetchListIfNeeded('_group', match.params.studyId));
  }

  _handleNewMaterialAlert(studyId) {
    const { studyStore, dispatch } = this.props;
    this.setState({
      confirmSendEmailsModalOpen: false
      , sendingEmails: true
    });
    dispatch(studyUserActions.sendNewStudyMaterialAlert(studyStore.selected.id)).then(action => {
      if(action.success) {
        this.setState({
          emailStatusMessage: `Emails sent`
          , emailStatusModal: true
          , emailStatusTitle: 'Success!!!'
          , emailStatusType: 'success'
          , sendingEmails: false
        });
      } else {
        this.setState({
          emailStatusMessage: `Something went wrong. Have FLabs check logs.`
          , emailStatusModal: true
          , emailStatusTitle: 'Error'
          , emailStatusType: 'danger'
          , sendingEmails: false
        });
      }
    });
  }

  _handleNewCustomStudyAlert() {
    const { studyStore, dispatch } = this.props;
    let data = {
      subject: this.state.customEmailSubject
      , body: this.state.customEmailBody
    }
    this.setState({
      customEmailModalOpen: false
      , sendingEmails: true
    });
    dispatch(studyUserActions.sendNewCustomStudyAlert(studyStore.selected.id, data)).then(action => {
      if(action.success) {
        this.setState({
          customEmailBody: ''
          , customEmailSubject: ''
          , emailStatusMessage: `Emails sent`
          , emailStatusModal: true
          , emailStatusTitle: 'Success!!!'
          , emailStatusType: 'success'
          , sendingEmails: false
        });
      } else {
        this.setState({
          emailStatusMessage: `Something went wrong. Have FLabs check logs.`
          , emailStatusModal: true
          , emailStatusTitle: 'Error'
          , emailStatusType: 'danger'
          , sendingEmails: false
        });
      }
    });
  }

  _handleDeactivateUsers(studyId) {
    const { studyStore, dispatch } = this.props;
    this.setState({
      deactivateUsersModalOpen: false
    });
    dispatch(studyUserActions.sendBulkDeactivateViaStudy(studyStore.selected.id))
  }

  _handleChange(e) {
    let newState = _.update(_.cloneDeep(this.state), e.target.name, () => {
      return e.target.value;
    });
    this.setState(newState);
  }

  _handleCompletionReminder() {
    this.setState({sendingEmails: true})
    const { dispatch, match } = this.props;
    dispatch(studyUserActions.sendBulkCompletionReminder(match.params.studyId)).then((suRes) => {
      if(suRes.success) {
        this.setState({
          confirmCompletionReminder: false
          , resultModalOpen: true
          , resultMessage: suRes.message
          , resultType: "success"
          , sendingEmails: false
        });
      } else {
        this.setState({
          confirmCompletionReminder: false
          , resultModalOpen: true
          , resultMessage: suRes.error
          , resultType: "danger"
          , sendingEmails: false
        });
      }
    });
  }

  _handleBulkReminder() {
    this.setState({sendingEmails: true})
    const { dispatch, match } = this.props;
    dispatch(studyUserActions.sendBulkOnboardingReminder(match.params.studyId)).then((action) => {
      if(action.success) {
        this.setState({
          confirmBulkResendModalOpen: false
          , resultModalOpen: true
          , resultMessage: action.message
          , resultType: "success"
          , sendingEmails: false
        });
      } else {
        this.setState({
          confirmBulkResendModalOpen: false
          , resultModalOpen: true
          , resultMessage: action.error
          , resultType: "danger"
          , sendingEmails: false
        });
      }
    });
  }

  // only for testing purposes
  // _thirdPartyInvite() {
  //   const { dispatch, studyStore } = this.props; 
  //   let study = _.cloneDeep(studyStore.selected.getItem()); 
  //   dispatch(studyUserActions.sendSponsorInvite({_organization: study._organization, _groupIds: [study._id, "5d083902df013900605bfe55", "5bff361695d64d0274dbb134"], email: 'austincline09+12@gmail.com', authToken: "664aa3d2ed42"})); 
  // }

  render() {
    const {
      courseStore
      , location
      , match
      , resourceLinkStore
      , sponsorMap
      , studyStore
    } = this.props;

    /**
     * use the selected.getItem() utility to pull the actual study object from the map
     */
    const selectedStudy = studyStore.selected.getItem();
    const courseListItems = courseStore.util.getList('_group', match.params.studyId);
    const resourceLinks = resourceLinkStore.util.getList('_group', match.params.studyId);
    const isEmpty = (
      !selectedStudy
      || !selectedStudy._id
      || studyStore.selected.didInvalidate
    );

    const noLinks = (
      !resourceLinks
      || resourceLinks.length < 1
    )

    let status = classNames(
      'status-pill'
      , { '-published': selectedStudy && selectedStudy.status === 'published' }
    )

    let reminderStatus = classNames(
      'status-pill'
      , { '-published': selectedStudy && selectedStudy.memberContent && selectedStudy.memberContent.sendReminders }
    )

    return (
      <TrainingManagementLayout>
        <Helmet
          title={"View Study | Pro-ficiency"}
        />
        <div className="flex">
          <section className="section">
            <div className="yt-container">
              <Breadcrumbs links={location.state.breadcrumbs} />
              { isEmpty ?
                (studyStore.selected.isFetching ? <h2>Loading...</h2> : <h2>Empty.</h2>)
                :
                <div style={{ opacity: studyStore.selected.isFetching ? 0.5 : 1 }}>
                  <div className="yt-row with-gutters">
                    <div className="yt-col full s_60 m_70 ">
                      <div className="content-container">
                        <div className="yt-row space-between">
                          <p><strong>Program Content Management</strong></p>
                          <div>
                            {/* <Link className="yt-btn x-small info" to={`${match.url}/update`}> Update general info </Link> */}
                            <a className="yt-btn small warning link" href={`${window.hubUrl}/super/groups/${match.params.studyId}`}>Access/Permissions &rarr;</a>
                            <Link className="yt-btn small info" to={`${match.url}/roles`}> Manage Training Roles </Link>
                            <Link className="yt-btn small warning" to={`${match.url}/sites`}>Manage Sites</Link>
                          </div>
                        </div>
                        <hr/>

                        <h2>{selectedStudy.name}</h2>
                        <p> <strong>Sponsor:</strong> <br/>{sponsorMap[selectedStudy._organization] ? sponsorMap[selectedStudy._organization].name : ""} </p>
                        <div className={status}>{_.startCase(selectedStudy.status).toUpperCase()}</div>

                        <br/>
                        <hr/><hr/>
                        <p><strong>Courses in this program</strong></p>
                        <hr/>
                        <div className="-quick-list">
                          {courseListItems && courseListItems.length > 0 ?
                            courseListItems.map((course, i) =>
                              <AdminCourseQuickListItem
                                key={course._id}
                                course={course}
                                study={selectedStudy}
                              />
                            )
                            :
                            <p className="u-centerText"><em>No courses yet</em></p>
                          }
                        </div>
                        {selectedStudy && selectedStudy.memberContent && selectedStudy.memberContent.hasAccess ? 
                          <Link to={`${match.url}/courses/new`} className="yt-btn link success x-small"><i className="fas fa-plus"/> New Course</Link>
                        : null 
                        }

                        <br/>
                        <hr/><hr/>
                        <p><strong>Resource links for the program</strong></p>
                        <hr/>
                        <div className="resource-links">
                          { noLinks ?
                            <em> No resource links yet </em>
                            :
                            resourceLinks.map((rLink, i) =>
                              <AdminResourceLinkListItem
                                dispatch={this.props.dispatch}
                                key={i}
                                refKey="_group"
                                refId={rLink._group}
                                resourceLink={rLink}
                              />
                            )
                          }
                        </div>
                        <button className="yt-btn x-small success link" onClick={() => this.setState({createLinkModalOpen: true })}><i className="fas fa-plus"/> Add Resource</button>
                        <br/>
                        <hr/>


                      </div>
                    </div>
                    <div className="yt-col full s_40 m_30">
                      <div className="content-container">
                        <div>
                          <a className="yt-btn fowler" href={`${window.hubUrl}/super/groups/${match.params.studyId}`}> Group / User Management &rarr;</a>
                        </div>
                      </div>
                      <div className="content-container">
                        <Link
                          className="yt-btn x-small warning"
                          to={`/admin/audit-logs/study/${selectedStudy._id}`}
                          target="_blank"
                        >
                          Object History &rarr;
                        </Link>
                        <br/>
                        <a className="yt-btn x-small danger" target="_blank" href={`/api/groups/${match.params.studyId}/role-report`}>
                          Program Admin Access Report &rarr;
                        </a>
                        <hr/>
                        <p>
                          Created on {DateTime.fromISO(selectedStudy.created).toLocaleString(DateTime.DATETIME_FULL)}
                          { selectedStudy._createdBy && userMap[selectedStudy._createdBy] ?
                            <span> by
                              <Link to={`/admin/users/${selectedStudy._createdBy}`} target="_blank"> {userMap[selectedStudy._createdBy].username}</Link>
                            </span>
                            : null
                          }
                        </p>
                        <p><small><em>Last updated {DateTime.fromISO(selectedStudy.updated).toLocaleString(DateTime.DATETIME_FULL)}</em></small></p>
                        <br/>
                      </div>
                      { selectedStudy.status === 'published' ?
                        <div className="content-container">
                          <div style={{paddingBottom: '10px'}}>
                            <div style={{paddingBottom: '10px'}}>
                              <button className="yt-btn block small danger" onClick={() => this.setState({confirmCompletionReminder: true})} disabled={this.state.sendingEmails}>{this.state.sendingEmails ? 'Sending...' : 'Send Completion Reminders'}</button>
                            </div>
                            <div>
                              <button className="yt-btn block small warning" onClick={() => this.setState({confirmBulkResendModalOpen: true})} disabled={this.state.sendingEmails}>{this.state.sendingEmails ? 'Sending...' : 'Send Onboarding Reminders' }</button>
                            </div>
                          </div>
                          <hr/>
                          <div style={{paddingTop: '10px'}}>
                            <div style={{paddingBottom: '10px'}}>
                              <button className="yt-btn block small fowler" onClick={() => this.setState({confirmSendEmailsModalOpen: true})} disabled={this.state.sendingEmails}>{this.state.sendingEmails ? 'Sending...' : 'Send New Program Amendment Alert'}</button>
                            </div>
                            <div>
                              <button className="yt-btn block small info" onClick={() => this.setState({customEmailModalOpen: true})} disabled={this.state.sendingEmails}>{this.state.sendingEmails ? 'Sending...' : 'Send New Custom Email Message'}</button>
                            </div>
                          </div>
                      </div>
                      : null
                      }
                    </div>
                  </div>
                  <ResourceLinkModal
                    closeModal={() => this.setState({createLinkModalOpen: false})}
                    dispatch={this.props.dispatch}
                    formType="Create"
                    isOpen={this.state.createLinkModalOpen}
                    refId={selectedStudy._id}
                    refKey="_group"
                    resourceLink={resourceLinkStore.defaultItem}
                  />
                  <StudyCustomEmailModal
                    closeAction={() => this.setState({customEmailModalOpen: false, customEmailBody: "", customEmailSubject: ""})}
                    isOpen={this.state.customEmailModalOpen}
                    confirmAction={this._handleNewCustomStudyAlert}
                    onChange={this._handleChange}
                    customEmailSubject={this.state.customEmailSubject}
                    customEmailBody={this.state.customEmailBody}
                  />
                  <AlertModal
                    alertMessage={<div> Are you <em>sure</em> you want to send an email to all active program users?</div> }
                    alertTitle="Send alert email"
                    closeAction={() => this.setState({confirmSendEmailsModalOpen: false})}
                    confirmAction={this._handleNewMaterialAlert}
                    confirmText="Yes, send alert email"
                    declineText="Never mind"
                    isOpen={this.state.confirmSendEmailsModalOpen}
                    type="warning"
                  />
                  <AlertModal
                    alertMessage={
                      <div>
                        <p>
                          <strong>CAUTION: </strong> Are you <em>sure</em> you want to send a training completion email reminder?
                        </p>
                        <p>This will send an email to <em>everyone</em> who has <em>ANY</em> incomplete simulations.</p>
                      </div>}
                    alertTitle="Confirm completion email reminder"
                    closeAction={() => this.setState({confirmCompletionReminder: false})}
                    declineText="Nevermind"
                    disabled={this.state.sendingEmails}
                    confirmAction={this._handleCompletionReminder}
                    confirmText={this.state.sendingEmails ? "Sending..." : "Yes, send reminder"}
                    isOpen={this.state.confirmCompletionReminder}
                    type="warning"
                  />
                  <AlertModal
                    alertMessage={this.state.resultMessage}
                    alertTitle="Reminder result"
                    closeAction={() => this.setState({resultModalOpen: false})}
                    disabled={this.state.sendingReminder}
                    confirmAction={() => this.setState({resultModalOpen: false})}
                    confirmText="Got it"
                    isOpen={this.state.resultModalOpen}
                    type={this.state.resultType}
                  />
                  <AlertModal
                    alertMessage={<div><strong>CAUTION: </strong> Are you <em>sure</em> you want to resend onboarding email reminders?  <br/><br/> FYI, a new email will go out to all study users who have not onboarded yet, and will make their <em>old</em> links invalid. </div>}
                    alertTitle="Confirm bulk resend invites"
                    closeAction={() => this.setState({confirmBulkResendModalOpen: false})}
                    declineText="Nevermind"
                    disabled={this.state.sendingEmails}
                    confirmAction={this._handleBulkReminder}
                    confirmText={this.state.sendingEmails ? "Sending..." : "Yes, send reminders"}
                    isOpen={this.state.confirmBulkResendModalOpen}
                    type="warning"
                  />
                </div>
              }
            </div>
          </section>
        </div>
      </TrainingManagementLayout>

    )
  }
}

AdminStudyTrainingManagement.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    courseStore: store.course
    , resourceLinkStore: store.resourceLink
    , sponsorMap: store.sponsor.byId
    , studyStore: store.study
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(AdminStudyTrainingManagement)
);



// WEBPACK FOOTER //
// modules/study/views/AdminStudyTrainingManagement.js.jsx